const processors = [
  // Replace all occurrences of a '.' with a ':'.
  v => v.replace(/\./i, ':'),

  // A digit string should be considered a time, which should be separated by a
  // ':'.
  v => (/^\d\d\d\d$/.test(v) ? `${v.substring(0, 2)}:${v.substring(2)}` : v),

  // A three digit string which is separated by a ':' should get a leading
  // zero.
  v => (/^\d:\d\d$/.test(v) ? `0${v}` : v),

  // And finally, we'll make sure that the string ends seconds.
  v => (/^\d\d:\d\d$/.test(v) ? `${v}:00` : v),
]

module.exports = input => processors.reduce((value, fn) => fn(value), input)
